import { render } from "./FormTableImportActionWidget.vue?vue&type=template&id=4227e2b6&ts=true"
import script from "./FormTableImportActionWidget.vue?vue&type=script&lang=ts"
export * from "./FormTableImportActionWidget.vue?vue&type=script&lang=ts"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__